// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"18":"product","177":"home","505":"case","551":"support","697":"news","823":"solution","965":"aboutus"}[chunkId] + "." + {"18":"8cdd65e0","177":"c0aa3e4c","505":"18120919","551":"272c26f8","697":"3af06766","823":"f073be2f","965":"bb1c3a28"}[chunkId] + ".js";
};